var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-buttom"},[_c('el-button',{attrs:{"size":_vm.size,"icon":_vm.icon,"type":_vm.type,"loading":_vm.loading},on:{"click":_vm.toClick}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }